import React from 'react'
import {Link} from 'react-router-dom'
import Icon from '../../shared/Icon'

const RouteLink = props => {

  let renderIcon = () => {
    if (props.icon) {
      return <Icon bgUrl={props.icon} />
    }
  }

  return (
    <Link to={props.path}>
      {renderIcon()}
      <span className="menu-text">{props.children}</span>
    </Link>
  )
}

Link.defaultProps = {
  icon: ''
}

export default RouteLink
